import { DynamicWidget } from '../../../shared/component/dynamic-widget/dynamic-widget';
import { MainMapService } from '../../../shared/service/main-map.service';
import { WidgetNotifyService } from '../../../shared/service/widget-notify.service';
import {EsriReactiveUtils} from "../../../config/esri.module";

export abstract class BaseWidget extends DynamicWidget {
  // The widget of this component
  private _expandWidget: __esri.Expand;
  private _id: string;
  // Flag if the widget sould be expanded on creation
  private _expandOnInit: boolean;
  public hiddenContainer = true;

  constructor(
    public mainMapService: MainMapService,
    public widgetNotifyService: WidgetNotifyService
  ) {
    super();
  }

  /**
   * @function _id
   * @returns {string}
   * @description Get the component ID reference
   */
  public get id(): string {
    return this._id;
  }

  /**
   * @function setInitValues
   * @param id
   * @param expand
   * @description Sets the initial values
   */
  public setInitValues(id: string, expand: boolean) {
    this._id = id;
    this._expandOnInit = expand;
    if (!expand) this.hiddenContainer = true;
  }

  public get expandOnInit(): boolean {
    return this._expandOnInit;
  }

  /**
   * @description Get the esri-expand widget
   */
  public get expandWidget(): __esri.Expand {
    return this._expandWidget;
  }

  /**
   * @description Set the esri-expand widget
   */
  public set expandWidget(expand: __esri.Expand) {
    this._expandWidget = expand;
  }
  /**
   * @function collapseWidget
   * @description Close the widget of this component with css animation
   */
  public collapseWidget() {
    this.expandWidget.collapse();
  }

  /**
   * @function removeWidgetFromMainMapUI
   * @description remove this expand widget from main-map UI
   */
  public removeWidgetFromMainMapUI(): void {
    return this.mainMapService.mapView.ui.remove(this._expandWidget);
  }

  /**
   * @function destroySelf
   * @description Notify with onComponentDestroySubject that this component
   * will be destroyed from the DOM and from memory.
   */
  public destroySelf() {
    this.widgetNotifyService.onComponentDestroySubject.next(this._id);
  }

  /**
   * @function destroySelf
   * @description Destroy the Esri Expand Widget of this component
   */
  public destroyWidget() {
    this._expandWidget.destroy();
  }

  /**
   * @function initWidgetListeners
   * @description
   *    1. Register Widget to MainMapService
   *    2. Open Widget on default if needed
   *    3. Close other widgets when this one get opened
   */
  public initWidgetListeners() {
    this.mainMapService.registerWidget(this.expandWidget);
    // Open this widget, will close other widgets
    EsriReactiveUtils.watch(
      () => this.expandWidget?.expanded,
      () => {
        if (this.expandWidget.expanded) {
          this.mainMapService.closeOtherWidgets(this.expandWidget);
          this.hiddenContainer = false;
        }
      }
    );

    // expand widget on create
    if (this._expandOnInit) {
      this.expandWidget.expand();
    }
  }
}
